import axios from "axios"

export class LogTime{
    constructor(_DATE_OBJECT=new Date()){
        this.DATE_OBJECT = _DATE_OBJECT
        this._y = this.DATE_OBJECT.getFullYear()
        this._m = (this.DATE_OBJECT.getMonth()+1 <10)? `0${this.DATE_OBJECT.getMonth()+1}`:this.DATE_OBJECT.getMonth()+1
        this._d = (this.DATE_OBJECT.getDate()<10)? `0${this.DATE_OBJECT.getDate()}`:this.DATE_OBJECT.getDate()
        this._hr = (this.DATE_OBJECT.getHours()<10)? `0${this.DATE_OBJECT.getHours()}`:this.DATE_OBJECT.getHours()
        this._min = (this.DATE_OBJECT.getMinutes()<10)? `0${this.DATE_OBJECT.getMinutes()}`:this.DATE_OBJECT.getMinutes()
        this._sec = (this.DATE_OBJECT.getSeconds()<10)? `0${this.DATE_OBJECT.getSeconds()}`:this.DATE_OBJECT.getSeconds()
        this._millsec = (this.DATE_OBJECT.getMilliseconds()>100? this.DATE_OBJECT.getMilliseconds() 
                            :this.DATE_OBJECT.getMilliseconds()>10? `0${this.DATE_OBJECT.getMilliseconds()}`
                                :this.DATE_OBJECT.getMilliseconds>0? `00${this.DATE_OBJECT.getMilliseconds()}`:"000")
    }
    getDate(){ 
        return this._y+"-"+this._m+"-"+this._d 
    }
    getShortDate(){ 
        return this._m+"/"+this._d 
    }
    getTime(){ 
        return this._hr+":"+this._min+":"+this._sec+","+this._millsec 
    }
    getTime_withoutSec(){ 
        return this._hr+":"+this._min
    }
    getTime_withoutMillsec(){ 
        if(isNaN(this._hr)){return'-'}
        if(isNaN(this._min)){return'-'}
        if(isNaN(this._sec)){return'-'}
        return this._hr+":"+this._min+":"+this._sec
    }
    getFullTime(){
        return this.getDate() + " " + this.getTime()
    }
    getFullTime_withoutMillsec(){
        return this.getDate() + " " + this.getTime_withoutMillsec()
    }
    getFullTime_withoutSec_and_Millsec(){
        return this.getDate() + " " + this.getTime_withoutSec()
    }
    getFullTime_withoutMillsec_Ttype(){
        return this.getDate() + "T" + this.getTime_withoutMillsec()
    }
    transMonth(){
        switch (parseInt(this._m)){
            case 1:
                return "Jan"
            case 2:
                return "Feb"
            case 3:
                return "Mar"
            case 4:
                return "Apr"
            case 5:
                return "May"
            case 6:
                return "Jun"
            case 7:
                return "Jul"
            case 8:
                return "Aug"
            case 9:
                return "Sup"
            case 4:
                return "Apr"
            case 10:
                return "Oct"
            case 11:
                return "Nov"
            case 12:
                return "Dec"
        }
    }
    getDay(){
        switch (this.DATE_OBJECT.getDay()){
            case 0:
                return "Sunday, "+this.transMonth()+" "+this._d+", " + this._y
            case 1:
                return "Monday, "+this.transMonth()+" "+this._d+", " + this._y
            case 2:
                return "Tuseday, "+this.transMonth()+" "+this._d+", " + this._y
            case 3:
                return "Wednesday, "+this.transMonth()+" "+this._d+", " + this._y
            case 4:
                return "Thursday, "+this.transMonth()+" "+this._d+", " + this._y
            case 5:
                return "Friday, "+this.transMonth()+" "+this._d+", " + this._y
            case 6:
                return "Saturday, "+this.transMonth()+" "+this._d+", " + this._y
        }
    }
}

export class User_localStorage{
    constructor(){
        this.account = localStorage.getItem('currentAccount')
        this.userINFO = JSON.parse(localStorage.getItem(this.account))
        this.email = (this.userINFO)? this.userINFO.email:"null"
        // this.role = this.userINFO.role
        // this.first_name = this.userINFO.first_name
        // this.last_name = this.userINFO.last_name
        // this.resident_assign = this.userINFO.resident_assign
        // this.id = this.userINFO.id
        // this.token = this.userINFO.token
    }
}

export class LogInformation{
    constructor(_component){
        this.component = _component
        this.time = new LogTime().getFullTime()
        this.user = new User_localStorage().email
    }
    recMount(){
        let data = {
            component: this.component,
            status: "mount",
            time: this.time,
            user: this.user,
            error: ""
        }
        axios({url:"http://127.0.0.1:8000/FE_ComponentRecord", method:"POST", data:data})
        .then(res=>{console.log(res);})
        .catch(err=>{console.log(err);})
        return data
    }
    recUnmount(){
        let data = {
            component: this.component,
            status: "unmount",
            time: this.time,
            user: this.user,
            error: ""
        }
        axios({url:"http://127.0.0.1:8000/FE_ComponentRecord", method:"POST", data:data})
        .then(res=>{console.log(res);})
        .catch(err=>{console.log(err);})
    }
    recError(e){
        let data = {
            component: this.component,
            status: "ERROR",
            time: this.time,
            user: this.user,
            error: e
        }
        axios({url:"http://127.0.0.1:8000/FE_ERROR", method:"POST", data:data})
        .then(res=>{console.log(res);})
        .catch(err=>{console.log(err);})
    }
}
